import React from 'react';
import { useLocation } from 'react-router-dom';

import { usePanel } from '../../../shared/public/hooks/use-panel.hook';
import ResponsivePanel from '../../../shared/public/components/ResponsivePanel.component';
import { PUBLIC_PANELS } from '../../../shared/public/constants/panel.constants';
import { PUBLIC_AUTHENTICATION_APP_PATHS } from '../../constants/authentication-paths.constants';
import LoginForm from './LoginForm.component';
import ForgotPasswordForm from './ForgotPasswordForm.component';
import SignupStepper from './signup/SignupStepper.component';

const PANEL_TITLES: Record<string, string> = {
  [PUBLIC_PANELS.LOGIN]: 'Connexion',
  [PUBLIC_PANELS.SIGNUP]: 'Créer un compte',
  [PUBLIC_PANELS.FORGOT_PASSWORD]: 'Mot de passe oublié',
};

const AuthenticationPanel: React.FC = () => {
  const { activePanel, replacePanel, closePanel } = usePanel();
  const location = useLocation();

  const isOnAuthenticationRoute = Object.values(PUBLIC_AUTHENTICATION_APP_PATHS).some((path) => {
    const base = path.replace('/:token', '');

    return location.pathname === base || location.pathname.startsWith(`${base}/`);
  });

  if (isOnAuthenticationRoute) return null;

  const isOpen = activePanel !== null && PANEL_TITLES[activePanel] !== undefined;

  return (
    <ResponsivePanel open={isOpen} title={isOpen ? PANEL_TITLES[activePanel as string] : ''} onClose={closePanel}>
      {activePanel === PUBLIC_PANELS.LOGIN && <LoginForm onSuccess={closePanel} onNavigate={replacePanel} />}
      {activePanel === PUBLIC_PANELS.SIGNUP && <SignupStepper onSuccess={closePanel} onNavigate={replacePanel} />}
      {activePanel === PUBLIC_PANELS.FORGOT_PASSWORD && <ForgotPasswordForm onNavigate={replacePanel} />}
    </ResponsivePanel>
  );
};

export default AuthenticationPanel;
